<template>
  <b-modal
    ref="create_report"
    id="create_report"
    scrollable
    size="lg"
    title="New Report"
    @shown="focusTitle"
    @hide="hideModal"
  >
    <b-alert variant="danger" show v-if="isError">An error occurred while submitting.</b-alert>
    <b-form>
      <b-form-group label="Title" label-cols-lg="2">
        <b-form-input
          ref="focusThis"
          v-model="report.title"
          :state="errors.title ? false : null"
          size="lg"
        />
        <div v-if="errors && errors.title" class="text-danger font-weight-bold">{{errors.title[0]}}</div>
      </b-form-group>
      <b-form-group label="Type" label-cols-lg="2">
        <b-form-select v-model="report.type" :state="errors.type ? false : null">
          <b-form-select-option v-for="(type, idx) in reportType" :key="idx" :value="idx">{{ type }}</b-form-select-option>
        </b-form-select>
        <div v-if="errors && errors.type" class="text-danger font-weight-bold">{{errors.type[0]}}</div>
      </b-form-group>
      <b-form-group label="Document" label-cols-lg="2">
        <b-form-file
          placeholder="Choose document..."
          v-model="report.file"
          @change="checkFile"
          :state="errors.file ? false : null"
        ></b-form-file>
        <div v-if="errors && errors.file" class="text-danger font-weight-bold">{{errors.file[0]}}</div>
      </b-form-group>
    </b-form>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="hideModal">Cancel</b-button>
      <b-button
        variant="success"
        class="mr-2"
        @click.prevent="submit()"
        :disabled="sending || fileToBig"
      >
        <b-spinner v-if="sending" small></b-spinner>
        <em v-else>
          <i class="fas fa-paper-plane"></i>
        </em>
        Submit
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import config from "@/config";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      sending: false,
      isError: false,
      errors: {},
      report: {
        title: '',
        type: '',
        file: '',
      },
      fileToBig: false,
      reportType: config.report_type,
      reportStatus: config.report_status,
      statusColor: config.report_status_color
    };
  },
  computed: {
    fileState() {
      return this.fileToBig ? false : null;
    }
  },
  methods: {
    ...mapActions({ saveReport: "report/saveReport" }),
    submit() {
      this.sending = true;
      this.saveReport(this.report)
        .then(res => {
          this.hideModal();
          this.makeToast(
            "success",
            "Saved",
            "Report " + res.data.title + " has been saved!"
          );
          this.errors = {};
        })
        .catch(err => {
          this.errors = err.response.data.errors;
          this.isError = true;
        })
        .then(() => {
          this.sending = false;
        });
    },
    focusTitle() {
      this.$refs.focusThis.focus();
    },
    hideModal() {
      this.$refs["create_report"].hide();
      this.errors = {};
      this.sending = false;
      this.report = {};
    },
    checkFile(event) {
      this.fileToBig = false;
      this.errors.file = null;
      if (event.target.files[0].size > 33554432) {
        this.fileToBig = true;
        this.errors.file = new Array();
        this.errors.file[0] = "Maximum allowed size is 32MB";
      }
    }
  }
};
</script>

<style>
</style>